import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ClockIcon, PlayCircleIcon, CheckCircleIcon } from 'lucide-react';
import { Lesson } from '../data/courseData';
import { useProgress } from '../hooks/useProgress';
interface LessonCardProps {
  lesson: Lesson;
  moduleId: string;
  courseId?: string;
  index: number;
}
export function LessonCard({
  lesson,
  moduleId,
  courseId,
  index
}: LessonCardProps) {
  const {
    isLessonComplete
  } = useProgress();
  const linkPath = courseId ? `/curs/${courseId}/modul/${moduleId}/lectie/${lesson.id}` : `/modul/${moduleId}/lectie/${lesson.id}`;
  const isComplete = courseId ? isLessonComplete(courseId, moduleId, lesson.id) : false;
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} animate={{
    opacity: 1,
    x: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.1
  }} data-id="element-1189">
      <Link to={linkPath} data-id="element-1190">
        <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100" data-id="element-1191">
          <div className="flex items-start justify-between mb-4" data-id="element-1192">
            <h3 className="text-lg font-bold text-[#132C53] flex-1" data-id="element-1193">
              {lesson.title}
            </h3>
            <div className="flex items-center space-x-2 flex-shrink-0 ml-2" data-id="element-1194">
              {isComplete && <div className="flex items-center space-x-1 bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-semibold" data-id="element-1195">
                  <CheckCircleIcon className="w-3 h-3" data-id="element-1196" />
                  <span data-id="element-1197">Finalizat</span>
                </div>}
              <PlayCircleIcon className="w-6 h-6 text-[#357BEB]" data-id="element-1198" />
            </div>
          </div>
          <p className="text-gray-600 text-sm mb-4" data-id="element-1199">{lesson.description}</p>
          <div className="flex items-center space-x-4" data-id="element-1200">
            <div className="flex items-center space-x-1 text-gray-500 text-sm" data-id="element-1201">
              <ClockIcon className="w-4 h-4" data-id="element-1202" />
              <span data-id="element-1203">{lesson.duration}</span>
            </div>
            <span className="text-[#357BEB] font-medium text-sm hover:underline" data-id="element-1204">
              {isComplete ? 'Revizuiește lecția →' : 'Deschide lecția →'}
            </span>
          </div>
        </div>
      </Link>
    </motion.div>;
}